import { useDropzone } from "react-dropzone";
import { IconUpload, IconX, IconFile } from "@tabler/icons-react";

const DropzoneField = ({ label, files, onDropFiles, onRequestDelete }) => {
  const onDrop = (acceptedFiles) => {
    onDropFiles(acceptedFiles);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "image/jpeg": [".jpg", ".jpeg"],
      "image/png": [".png"],
      "application/pdf": [".pdf"],
    },
    maxFiles: 10,
  });

  return (
    <div className="mb-4">
      <label className="form-label fw-bold">{label}</label>

      {files.length > 0 && (
        <div className="row g-3 mb-3">
          {files.map((file, index) => (
            <div className="col-md-4" key={index}>
              <div className="card p-2 position-relative">
                <button
                  type="button"
                  className="btn btn-sm btn-danger position-absolute top-0 end-0"
                  onClick={() => onRequestDelete(index)}
                >
                  <IconX size={16} />
                </button>

                {file.type.startsWith("image") ? (
                  <img
                    src={file.preview}
                    alt={file.name}
                    style={{
                      width: "100%",
                      height: "180px",
                      objectFit: "contain",
                      objectPosition: "center",
                      backgroundColor: "#f8f9fa",
                      borderRadius: "0.5rem",
                    }}
                  />
                ) : (
                  <div className="text-center py-4">
                    <IconFile size={40} />
                    <div className="small mt-2">{file.name}</div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      <div
        {...getRootProps()}
        className={`border border-2 rounded-3 p-5 text-center ${
          isDragActive ? "border-primary bg-light" : ""
        }`}
      >
        <input {...getInputProps()} />
        <IconUpload size={48} className="mb-3 text-primary" />
        <p className="fw-bold mb-1">Húzza ide vagy kattintson</p>
        <p className="text-muted mb-0">JPG, PNG, PDF – max. 5MB</p>
      </div>
    </div>
  );
};

export default DropzoneField;
